$(function () {
	$('.section-cart').each(function(index, el) {
		let lazyLoad = new LazyLoad({
			container: $(el).get(0),
			elements_selector: '.lazyload'
		});
	});

	$('.section-cart .js-item-delete').on('click', function(e) {
		let $this = $(this),
			url = $this.data('href');
		e.preventDefault();

		var http = new XMLHttpRequest();
		http.open('get', url, true);
		http.setRequestHeader("Content-type","application/json");
		http.send();
		$parent = $this.parents('.cart-item').remove();
		if ($('.section-cart form .cart-items .cart-item').length == 0) {
			$('.section-cart').addClass('is-empty');
		}
	});
	$('.section-cart .quantity-controls button').on('click', function(e) {
		let $this = $(this),
			$input = $this.parents('.quantity-block').find('input.rev-input'),
			change = Number($this.data('quantity-change')),
			val = 0;

			console.log();
		e.preventDefault();
		val = $input.val();
		val = Number(val) + change;
		if (val > 0) {
			$input.val(val);
			$input.change();
		}
	});

	$('.section-cart .quantity-block input').on('change', function(e) {
		let $this = $(this),
			timer = $this.data('timer');
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(() => {
			$this.removeData('timer');
			let data = {
				'id': $this.data('id'),
				'quantity': $this.val()
			  };
			var http = new XMLHttpRequest();
			  http.onload = () => {
				$this.parents('.cart-item').removeClass('is-updating');
				if ($('.cart-item.is-updating').length == 0) {
					$('.section-cart form.cart').removeClass('is-updating');
				}
			  }
			$this.parents('.cart-item').addClass('is-updating');
			$('.section-cart form.cart').addClass('is-updating');
			http.open('POST', '/cart/change', true);
			http.setRequestHeader('Content-Type','application/json');
			http.send(JSON.stringify(data));
		}, 600);
		$this.data('timer', timer);
	});

	window.addEventListener("cart_changed", function(e) {
		console.log(e.detail);
		let cart = e.detail.cart;
		$('.section-cart .cart-controls .total-amount').html(formatMoney(cart.total_price));	
		$('.section-cart .cart-controls .total-amount-old').html(formatMoney(cart.original_total_price));
		cart.items.forEach(el => {
			let $item = $('.cart-item[data-item-id='+el.id+']');
			$item.find('.price').html(formatMoney(el.final_price));
			$item.find('.price-old').html(formatMoney(el.original_price));
			$item.find('.total-price').html(formatMoney(el.final_line_price));
			$item.find('.total-price-old').html(formatMoney(el.original_line_price));
		});
	});
});